import React, { useReducer, useState } from "react"
import { useLocation } from '@reach/router';
import Modal from 'react-modal';
import classNames from "classnames";
import { Link } from "gatsby";
import { getCookie } from "../utils/utils";
Modal.setAppElement('#___gatsby');
/**
 * Portal ID: 4258421
 * Form ID: cd2cad50-b4bc-4a16-8977-03fdaef8aca4
 * https://legacydocs.hubspot.com/docs/methods/forms/submit_form
 */

  const ContactForm = (props) =>  {

    // let [modalIsOpen, setModalIsOpen] = useState(true);
    let [modalText, setModalText] = useState();
    let [loading, setLoading] = useState(false);

    const action = 'https://api.hsforms.com/submissions/v3/integration/submit/4258421/cd2cad50-b4bc-4a16-8977-03fdaef8aca4';

        const location = useLocation();
        // Request JSON:
        var requestData = {
            "fields": [],
            "context": {
                "pageUri": location.href,
                "pageName": props.pageName,
                "hutk": getCookie("hubspotutk")
            },
            "legalConsentOptions":{ // Include this object when GDPR options are enabled
              "consent":{
                "consentToProcess":true,
                "text":"I agree to allow Grundium to store and process my personal data.",
                "communications":[
                  {
                    "value":true,
                    "subscriptionTypeId":999,
                    "text":"I agree to receive other communications from Grundium."
                  }
                ]
              }
            }
          }

    const [formValue, setFormValue] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
            firstname: "",
            lastname: "",
            email: "",
            company: "",
            message: "",
            country: "",
         }
      );
    let [commConsent, setCommConsent] = useState(false);
    // let [converted, setConverted] = React.useState(false);

    const setBusy = busy => {
        if (busy) {
            setLoading(true);
            setModalText({spinner: <h4 className="fw300">Submitting request</h4>})
        } else {
            setLoading(false);
            setModalText(undefined)
        }
    }

    const handleSubmit = e => {
        requestData['fields'] = Object.keys(formValue).map(key => ({ name: key, value: formValue[key]}));
        requestData['legalConsentOptions']['consent']['communications'][0]['value'] = commConsent;
        
        // console.warn(requestData);

        const requestBody = JSON.stringify(requestData)
        setBusy(true);
        
        fetch(action, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: requestBody
        })
        .then(response => response.json())
        .then(data => {
            setBusy(false);
            // console.log("Response: ", data);
            if (data && data.inlineMessage) {
                // data.link = {href: "/", text: "Back to home page"};
                setModalText(data);
                // countConversion();
                // console.warn("Success:", data.inlineMessage);
            } 
            else if (data && data.errors) {
                setModalText({
                    inlineMessage: "<h4>There was an error submitting the form</h4> Double check required fields and try again.",
                });
                // console.warn("Error:", data.message);
            }
            
        })
        .catch(error => {
            setBusy(false);
            setModalText({message: "<h4>Something went wrong</h4> There was an error submitting the form, please try again later."})
            error("Error submitting the form", error)
        });

        e.preventDefault();
    };

    const handleChange = e => setFormValue({ [e.target.name]: e.target.value });

      return (
        <div>
            <form onSubmit={handleSubmit} className={classNames("form", {"form--disabled": loading})} id="form-contact">
                <div className="form-row form-row--2">
                    <div className="form-field form-field--half mb20">
                        <label htmlFor="firstname">First name <span className="gs-color-yellow">*</span></label>
                        <input type="text" name="firstname" required value={formValue.firstname} onChange={handleChange} />
                    </div>
                    <div className="form-field form-field--half mb20">
                        <label htmlFor="lastname">Last name <span className="gs-color-yellow">*</span></label>
                        <input type="text" name="lastname" required value={formValue.lastname} onChange={handleChange} />
                    </div>
                </div>
                <div className="form-row form-row--3">
                    <div className="form-field form-field--third mb20">
                        <label htmlFor="email">Email <span className="gs-color-yellow">*</span></label>
                        <input type="email" name="email" required value={formValue.email} onChange={handleChange} />
                    </div>
                    <div className="form-field form-field--third mb20">
                        <label htmlFor="company">Company <span className="gs-color-yellow">*</span></label>
                        <input type="text" name="company" required value={formValue.company} onChange={handleChange} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-field mb20">
                        <label htmlFor="country">Country <span className="gs-color-yellow">*</span></label>
                        <input type="text" name="country" required value={formValue.country} onChange={handleChange} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-field">
                        <label htmlFor="message">{ (props.labels && props.labels.message) ? props.labels.message : "Your message"} <span className="gs-color-yellow">*</span></label>
                        <textarea name="message" required rows="6"  value={formValue.message} onChange={handleChange} ></textarea>
                    </div>
                </div>

                <div>
                    <p className="gs-text--small gs-text--dimm mb2">
                        Grundium is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below:
                    </p>
                    
                    <div className="form-row">
                      <div className="form-field">
                        <input type="checkbox" id="consent" name="consent" checked={commConsent} onChange={(e)=>setCommConsent(!commConsent)}/>
                        <label htmlFor="consent">I agree</label>
                      </div>
                    </div>
                
                </div>
                <div className="form-row">
                    <button type="submit" className="gs-button gs-color-contrast">SUBMIT</button>
                </div>
            </form>
          <Modal
            isOpen={!!modalText}
            contentLabel="Info message"
            className="gs-modal-content"
            overlayClassName="gs-modal gs-modal--dimm"
          >
            <div className="gs-modal-message gs-container gs-container--600 gs-bg-1 tac">

                {
                    modalText && modalText.spinner && modalText.spinner
                }
                {
                    modalText && modalText.message && (
                        <div className="">
                            <p className="mb1">{modalText.message}</p>
                            {
                                modalText.link && <Link to={modalText.link.href}>{modalText.link.text}</Link>
                            }
                            {
                                !modalText.link && <button
                                        className="gs-button gs-color-contrast"
                                        onClick={()=>setModalText(undefined)}
                                        >CLOSE</button>
                            }
                        </div>
                    )
                }
                {
                    modalText && modalText.inlineMessage && (
                        <div className="">
                            <p dangerouslySetInnerHTML={{ __html: modalText.inlineMessage }} className="mb1"></p>
                            {
                                modalText.link && <Link to={modalText.link.href}>{modalText.link.text}</Link>
                            }
                            {
                                !modalText.link && <button
                                        className="gs-button gs-color-contrast"
                                        onClick={()=>setModalText(undefined)}
                                        >CLOSE</button>
                            }
                            
                            
                        </div>
                    )
                }
            </div>
          </Modal>
        </div>
      );
  }

  export default ContactForm